module.exports = __webpack_public_path__ + "static/media/background_5.728c29b3.jpg";